export default __webpack_public_path__ + "sharp-sans-bold-0817ae968cb5440b4b63374f9737e4b9.bundle.woff2";